export default "__VITE_ASSET__9492a2fc__"